
  export enum SideNavBarButtonsEnum {
    ViewGroup = 'view',
    ViewStructure = 'view__structure',
    BimModels = 'bimModels',
    Sections = 'bimSections',
    Plans = 'plans',
    Missions = 'missions',
    Structures = 'structure',
    Customer = 'customer'
  }
